<template>
    <div class="radarView" :id="`view-${id}`">
        <!-- <canvas :width="canvasWidth" :height="canvasHeight" :id="id"></canvas> -->
        <div class="listView">
            <div class="item" v-for="(item, index) in RadarData" :key="index">
                <div class="labelView" v-if="item?.max > 0">
                    <div class="label">{{ item?.name }}</div>
                    <div class="number">{{ Number((item?.value / item?.max)?.toFixed(1)) * 100 }}%</div>
                </div>
                <Process :cur_kep="item.value" :total_kep="item.max" :showText="false" id="echart" v-if="item?.max > 0"></Process>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import Process from "../../Process";
// import { getTime } from "@/utils/utils";
// import { px2rem } from "@//utils/utils.js";
// import * as echarts from 'echarts/core';
// import { RadarChart } from 'echarts/charts';
// import { CanvasRenderer } from 'echarts/renderers';
// echarts.use([RadarChart, CanvasRenderer]);

export default {
    components: {
        Process
    },
    props: {
        DataBase: {
            type: Object,
            default: () => {
                return null
            }
        },
        canvasWidth: {
            type: Number,
            default: 282
        },
        canvasHeight: {
            type: Number,
            default: 205
        },
        RadarData: {
            type: Array,
            default: () => {
                return [];
            }
        },
        id: {
            type: String,
            default: 'rader-canvas'
        }
    },
    computed: {
        ...mapState({
            init: (state) => state.global.init,
            statusBarHeight: (state) => state.global.statusBarHeight,
            languageEnv: (state) => state.global.languageEnv,
            languagePackage: (state) => state.global.languagePackage,
        }),
    },
    watch: {
        RadarData: {
            async handler(value) {
                // console.log('radarchart: ', value);
                if(value){
                    this.nowRenderTimes++;
                    this.chartInit(value);
                }
            },
            immediate: true,
            deep: true,
        }
    },
    setup(props, { emit }) {
        const { id, RadarData } = props;
        /**语言包 - ref */
        const localesPackage = ref({});
        /**语言环境 - ref */
        const localesEnv = ref('en');
        // const chartDom = ref(null);
        // const myChart = ref(null);
        // const option = ref({
        //     radar: {
        //         indicator: [
        //             RadarData?.map(item => {
        //                 return {
        //                     name: item.name,
        //                     max: item.max
        //                 }
        //             })
        //         ],
        //         splitArea: {
        //             show: false
        //         },
        //         splitLine: {
        //             lineStyle: {
        //                 color: 'rgba(31, 34, 37, 0.5)'
        //             }
        //         },
        //         axisLine: {
        //             lineStyle: {
        //                 color: 'rgba(31, 34, 37, 0.5)'
        //             }
        //         },
        //         axisName: {
        //             color: 'rgba(31, 34, 37, 1)',
        //             fontFamily: 'PingFang SC',
        //             fontSize: 10,
        //             lineHeight: 10.5,
        //         },
        //         nameGap: 4, // 指示器名称间距
        //         radius: '75%',
        //         startAngle: 90,
        //     },
        //     series: [
        //         {
        //             type: 'radar',
        //             data: [
        //                 {
        //                     value: [
        //                         RadarData?.map(item => item.value)
        //                     ],
        //                     lineStyle: {
        //                         width: 1,
        //                         color: 'rgba(0, 0, 0, 1)'
        //                     },
        //                     symbol: 'none', // 禁用圆点
        //                     areaStyle: {
        //                         // 雷达区块背景配置
        //                         color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
        //                             {
        //                                 color: 'rgba(243, 196, 105, 0.4)',
        //                                 offset: 0
        //                             },
        //                             {
        //                                 color: 'rgba(189, 145, 79, 0.71)',
        //                                 offset: 1
        //                             }
        //                         ])
        //                     },
        //                 }
        //             ]
        //         }
        //     ]
        // });
        const nowRenderTimes = ref(0);

        onBeforeMount(()=>{
            appBridging.getStatusBarHeight();
        })
        
        onMounted(()=>{
            // 雷达图逻辑
            // chartDom.value = document.getElementById(id);
            // myChart.value = echarts.init(chartDom.value, null, { 
            //     renderer: 'svg', 
            //     devicePixelRatio: window.devicePixelRatio || 1
            // });
            // nowRenderTimes.value++
            // if(nowRenderTimes.value >= 2){
            //     myChart.value.setOption(option.value);
            //     // console.log('sssssssssssssssssssssssss action');
            // }
        })

        const chartInit = (radarOptionData) => {
            // 雷达图逻辑
            // const optionLocal = _.cloneDeep(option.value);
            // if(!optionLocal || radarOptionData.length <= 0)return;
            // optionLocal.radar.indicator = radarOptionData.map(item => {
            //     return {
            //         name: item.name,
            //         max: item.max
            //     }
            // })
            // optionLocal.series[0].data[0].value = radarOptionData.map(item => item.value);
            // option.value = optionLocal;
            // if(nowRenderTimes.value >= 2){
            //     myChart.value.setOption(optionLocal);
            //     // console.log('sssssssssssssssssssssssss action');
            // }
            // 柱状图逻辑
            console.log("radarOptionData: ", radarOptionData);
        }

        return {
            localesPackage,
            localesEnv,
            // option,
            chartInit,
            nowRenderTimes
        };
    },
};
</script>
  
<style lang="less" scoped>
.radarView{
    width: 100%;
    height: 100%;
    canvas{
        width: 100%;
        height: 100%;
    }
    .listView{
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        margin-top: 13px;
        .item{
            width: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-family: "PingFang SC";
            // height: 24px;
            margin-bottom: 13px;
            .labelView{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                margin-bottom: 6px;
                .label{
                    color: #1f2225;
                    font-size: 13px;
                    font-weight: 400;
                    opacity: 0.8;
                }
                .number{
                    color: #634d00;
                    font-size: 15px;
                    font-weight: 600;
                }
            }
            #p-echart{
                position: unset;
                height: 8px;
                :deep(.progress-bg){
                    height: 6px;
                    background: rgba(185, 177, 163, 0.3);
                    border: 1px solid #1F2225;
                    .progress-bg-line{
                        background: rgba(228, 185, 103, 1);
                        height: 4px;
                    }
                }
            }
        }
    }
}
</style>
  